module.exports = __webpack_public_path__ + "img/qrcode.0c023887.png";